import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  changeQueryParams,
  selectItemsIds,
  selectPagination,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import TasksHeaderSort from 'components/Tasks/TasksHeaderSort';
import PaginationBlock from '../../Common/Pagination/PaginationBlock/index';
import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';
import TaskItemNewTasks from './TaskItemNewTasks';

const tasksCollectionRName = 'tasksModule.collections.tasksCollection';

// eslint-disable-next-line react/prefer-stateless-function
class TasksListNewTasks extends Component {
  render() {
    let comments = null;
    if (this.props.requestStatus.inProgress) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => {
            const task = this.props.selectItemById(itemId);
            if (task) {
              return (
                <TaskItemNewTasks
                  key={`taskItemAsOwner${itemId}`}
                  task={task}
                  isTaskFromAuthUser={
                    this.props.authUserId.toString() === task.ownerId.toString()
                  }
                />
              );
            }
            return null;
          })}
          <PaginationBlock
            paginationData={this.props.paginationData}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
              window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            }}
          />
        </React.Fragment>
      );
    } else {
      comments = (
        <div className="alert alert-default text-center">
          <p>
            {t('Задания, соответствующие вашим требованиям, не найдены :-(')}
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <TasksHeaderSort listReduceName={this.props.reducerName} />
        {comments}
      </React.Fragment>
    );
  }
}

TasksListNewTasks.propTypes = {
  // IN
  reducerName: PropTypes.string.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestStatus: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  authUserId: PropTypes.string.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  authUserId: `${selectUserId(state)}`,
  requestStatus: selectRequestState(state, props.reducerName),
  paginationData: selectPagination(state, props.reducerName),
  itemsIds: selectItemsIds(state, props.reducerName),
  selectItemById: id => selectItemById(state, tasksCollectionRName, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.reducerName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.reducerName, queryParams))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksListNewTasks)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListNewTasks/TasksListNewTasks.js